import * as actions from './actions'
import reducer from './reducer'

export { actions, reducer as default }



// WEBPACK FOOTER //
// ./services/app-state/personalizedRecommendation/index.js